<template>
    
            <div class="footer">
      <a href="https://www.instagram.com/aditudorr/">instagram</a>
      <a href="https://www.linkedin.com/in/qulpe/">linkedin</a>
    </div>
    
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.footer{
  height: 60px;
  width: 100%;
  background: #000;
  color: #fff;
  display: grid;
  place-items: center;
}
@media screen and (max-width: 600px) {
    .footer{
        margin: 50px 0 0 0;
    }
}
</style>